import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { NormalizedInterval } from 'date-fns'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class RexStadiumEventsRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      uiScope,
      scopedStudents,
      ...stats,
    }
  }

  makeStatsRequests = async (product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) => {
    return RSVP.hash({
      stadiumEventsTotals: this.studentEvents.stadiumEventsTotals(product, scope, period),
      stadiumEventsHistory: this.studentEvents.stadiumEventsHistory(product, scope, period),
    })
  }
}

export default RexStadiumEventsRoute
